import Ribbon from 'components/common/Ribbon/Ribbon'
import RibbonButton from 'components/common/Ribbon/RibbonComponents/RibbonButton'

import { Box } from '@mui/material'
import { Icon as Iconify } from '@iconify/react'
import { checkPermission, checkFeature } from 'components/userPermissions'

const AlertGroupRibbon = ({
  selectedGroup,
  onRefresh,
  onAddGroup,
  onEditGroup,
  onDeleteGroup,
  isDeleting,
  userRole,
  onAlerts,
}) => {
  const panels = []

  panels.push({
    panelName: '',
    items: [
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <RibbonButton
          height={55}
          iconSize={40}
          icon={<Iconify icon='material-symbols:refresh' width={20} />}
          label='Refresh'
          onClick={onRefresh}
        />
      </Box>,
    ],
  })

  panels.push({
    panelName: '',
    items: [
      <Box sx={{ display: 'flex', gap: 0.5 }}>
        <RibbonButton
          height={55}
          iconSize={40}
          icon={<Iconify icon='material-symbols:add' width={20} color='green' />}
          label='Add Group'
          onClick={onAddGroup}
        />

        {selectedGroup && (
          <RibbonButton
            height={55}
            iconSize={40}
            icon={<Iconify icon='material-symbols:edit' width={20} color='#1976d2' />}
            label='Edit'
            onClick={onEditGroup}
          />
        )}

        {checkPermission('canDelete', userRole.roleAttributes?.permissions) && selectedGroup && (
          <RibbonButton
            height={55}
            iconSize={40}
            icon={<Iconify icon='material-symbols:delete' width={20} color='#d32f2f' />}
            label='Delete'
            disabled={isDeleting}
            onClick={() => onDeleteGroup(selectedGroup)}
          />
        )}

        {checkFeature(51, userRole?.roleAttributes?.featureId) && selectedGroup && (
          <RibbonButton
            height={55}
            iconSize={40}
            icon={<Iconify icon='vaadin:bell' width={20} />}
            label='Alerts'
            onClick={onAlerts}
          />
        )}

      </Box>,
    ],
  })

  return <Ribbon barHeight={90} tabs={[{ panels }]} />
}

export default AlertGroupRibbon
